import { render } from "./ResearchNotebook.vue?vue&type=template&id=0d78c5e8&scoped=true"
import script from "./ResearchNotebook.vue?vue&type=script&lang=js"
export * from "./ResearchNotebook.vue?vue&type=script&lang=js"

import "./ResearchNotebook.vue?vue&type=style&index=0&id=0d78c5e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d78c5e8"]])

export default __exports__